import React ,{ useEffect, useState} from "react";
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import Footer from "../../components/Footer";
import { useNavigate, Link } from "react-router-dom";
import { stringify } from "querystring";
import { useDispatch, useSelector } from "react-redux";
import { GetOrdersAction } from "../../redux/actions/UserActions";
import { Helmet } from 'react-helmet';
import { customFormat} from "../../utils/Helper";
import './my_order.css';

type SeoContent = {
  meta_title: string;
  meta_description?: string;
  // Add more fields as needed
};

interface OrderListResponse {
  data: {
    rows: any[];
    count: number;
  };
}

const MyOrder: React.FC = () => {

    const dispatch = useDispatch<any>();
    const [soeContent, setSoeContent] = useState<SeoContent | null>(null);
    const [dataList, setDataList] = useState<OrderListResponse | null>(null);
    //const [loading, setLoading] = useState<boolean>(true);
    const {data ,status , loading, error} = useSelector((state: any) => state.getOrdersState || []);

    useEffect(() => {
      dispatch(GetOrdersAction({}));
    }, [dispatch])


    useEffect(() => {
      console.log("Orders : " , data);
      if ( status && data?.data) {
        setDataList(data);
      }
    }, [status,data])

  return (
    <>
    <Helmet>
      <title>{`${soeContent?.meta_title || 'Order Confirmation'}`}</title>
      <meta name="title" content={soeContent?.meta_title || 'E-learning Platform'} />
      <meta name="description" content={soeContent?.meta_description || 'Learn with curated e-learning resources'} />
      <meta name="keywords" content="e-learning, tech-cards, cheat-sheets, tutorials" />
    </Helmet>

      <Header />

      <div className="container py-5">
          <div className="row">

                <Sidebar />

                <div className="col-lg-9">
                    <div className="main-content">

                        {/* Filter Controls */}
                        {/* <div className="filter-controls">
                          <div className="row align-items-center">
                            <div className="col-md-4 mb-3 mb-md-0">
                              <label htmlFor="timeFilter" className="form-label">
                                Time Period
                              </label>
                              <select className="form-select" id="timeFilter">
                                <option defaultValue="All time">All time</option>
                                <option>Last 30 days</option>
                                <option>Last 3 months</option>
                                <option>Last 6 months</option>
                                <option>Last year</option>
                              </select>
                            </div>
                            <div className="col-md-4 mb-3 mb-md-0">
                              <label htmlFor="statusFilter" className="form-label">
                                Order Status
                              </label>
                              <select className="form-select" id="statusFilter">
                                <option defaultValue="All statuses">All statuses</option>
                                <option>Completed</option>
                                <option>Processing</option>
                                <option>Cancelled</option>
                              </select>
                            </div>
                            <div className="col-md-4">
                              <label htmlFor="searchOrders" className="form-label">
                                Search Orders
                              </label>
                              <div className="input-group">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="searchOrders"
                                  placeholder="Search by order # or course"
                                />
                                <button className="btn btn-outline-secondary" type="button">
                                  <i className="bi bi-search"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div> */}

                        {/* Orders List */}
                        <div className="content-container mt-5 pb-5">
                          <h2 className="mb-4">Order History</h2>

                          {/* Order 1 */}


                          {(dataList as any)?.data?.rows.length > 0 ? (
                            (dataList as any)?.data?.rows?.map((item: any) => (
                                <div className="order-card" key={item.id}>
                                  <div className="d-flex flex-column flex-md-row justify-content-between mb-3">
                                    <div>
                                      <h4 className="mb-1">Order #{item.order_id}</h4>
                                      <div className="d-flex align-items-center">
                                        <span className="order-status status-completed me-2">
                                          Completed
                                        </span>
                                        <span className="text-muted small">{customFormat(item.created_at)}</span>
                                      </div>
                                    </div>
                                    <div className="mt-2 mt-md-0">
                                      <Link className="btn btn-sm btn-outline-primary me-2" to={"/order-details/"+item.id}><i className="bi bi-eye me-1"></i>View Details</Link>
                                    </div>
                                  </div>

                                  <div className="row">

                                    <div className="col-md-8">

                                        {item.orders && item.orders.length > 0 ? (
                                          item.orders.map((order: any) => (
                                            <div className="course-item" key={order.id}>
                                              {/* <img
                                                src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=1170&q=80"
                                                className="course-item-img"
                                                alt="Data Science"
                                              /> */}
                                              <span className="cart-custom-icon">
                                                {order?.category?.icon}
                                              </span>
                                              <div className="course-item-details">
                                                <h5 className="course-item-title">{order?.category?.name}</h5>
                                                <p className="course-item-instructor">{order?.category?.single_line}</p>
                                                <div className="d-flex align-items-center">
                                                  <span className="badge bg-success me-2">{order?.groups?.name}</span>
                                                </div>
                                              </div>
                                              <div className="course-item-price">{order?.currency} {order?.price}</div>
                                            </div>
                                          ))
                                        ) : null}
                                    </div>
                                    <div className="col-md-4">
                                      <div className="order-summary-item pb-4">
                                        <span>Subtotal (1 items)</span>
                                        <span>{item.currency} {item.amount}</span>
                                      </div>
                                      
                                      <div className="order-summary-item order-summary-total pt-2">
                                        <span>Total</span>
                                        <span>{item.currency} {item.amount}</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                            ))
                          ) : (
                            <div className="content-container empty-state" >
                                <i className="bi bi-cart-x empty-state-icon"></i>
                                <h3 className="mb-3">No orders found</h3>
                                <p className="text-muted mb-4">
                                  You haven't placed any orders yet. Browse our artifacts to get
                                  started.
                                </p>
                                <Link style={{width:"30%"}} to={"/"} className="btn btn-primary"><i className="bi bi-search me-2"></i>Explore Artifacts</Link>
                              </div>
                            )}

                          {/* <div className="order-card">
                            <div className="d-flex flex-column flex-md-row justify-content-between mb-3">
                              <div>
                                <h4 className="mb-1">Order #UPL-2023-78945</h4>
                                <div className="d-flex align-items-center">
                                  <span className="order-status status-completed me-2">
                                    Completed
                                  </span>
                                  <span className="text-muted small">July 15, 2025</span>
                                </div>
                              </div>
                              <div className="mt-2 mt-md-0">
                                <a
                                  href="#"
                                  className="btn btn-sm btn-outline-primary me-2"
                                >
                                  <i className="bi bi-eye me-1"></i>View Details
                                </a>
                                <a href="#" className="btn btn-sm btn-outline-secondary">
                                  <i className="bi bi-receipt me-1"></i>Invoice
                                </a>
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-md-8">
                                <div className="course-item">
                                  <img
                                    src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=1170&q=80"
                                    className="course-item-img"
                                    alt="Data Science"
                                  />
                                  <div className="course-item-details">
                                    <h5 className="course-item-title">
                                      Data Science Fundamentals
                                    </h5>
                                    <p className="course-item-instructor">Dr. Sarah Johnson</p>
                                    <div className="d-flex align-items-center">
                                      <span className="badge bg-success me-2">NEW</span>
                                      <span className="small text-muted">Access granted</span>
                                    </div>
                                  </div>
                                  <div className="course-item-price">$49.99</div>
                                </div>

                                <div className="course-item">
                                  <img
                                    src="https://images.unsplash.com/photo-1563986768609-322da13575f3?auto=format&fit=crop&w=1170&q=80"
                                    className="course-item-img"
                                    alt="Machine Learning"
                                  />
                                  <div className="course-item-details">
                                    <h5 className="course-item-title">
                                      Machine Learning with Python
                                    </h5>
                                    <p className="course-item-instructor">
                                      Prof. Michael Chen
                                    </p>
                                    <div className="d-flex align-items-center">
                                      <span className="badge bg-success me-2">NEW</span>
                                      <span className="small text-muted">Access granted</span>
                                    </div>
                                  </div>
                                  <div className="course-item-price">$59.99</div>
                                </div>
                              </div>

                              <div className="col-md-4">
                                <div className="order-summary-item">
                                  <span>Subtotal (2 items)</span>
                                  <span>$109.98</span>
                                </div>

                                <div className="order-summary-item">
                                  <span>Discount</span>
                                  <span className="text-success">-$10.00</span>
                                </div>

                                <div className="order-summary-item">
                                  <span>Tax</span>
                                  <span>$9.50</span>
                                </div>

                                <div className="order-summary-item order-summary-total">
                                  <span>Total</span>
                                  <span>$109.48</span>
                                </div>
                              </div>
                            </div>
                          </div> */}



                        </div>

                        {/* Empty State */}
                        {/* <div
                          className="content-container empty-state"
                          style={{ display: "none" }}
                        >
                          <i className="bi bi-cart-x empty-state-icon"></i>
                          <h3 className="mb-3">No orders found</h3>
                          <p className="text-muted mb-4">
                            You haven't placed any orders yet. Browse our courses to get
                            started.
                          </p>
                          <a href="/" className="btn btn-primary">
                            <i className="bi bi-search me-2"></i>Explore Items
                          </a>
                        </div> */}


                    </div>
                </div>

          </div>
      </div>



      <Footer />
    </>
  );
};

export default MyOrder;
